import React from "react";
import Deactivation from "../../sections/CustomerDashboard/Dashboard/Deactivation";
import { AdminPageTitle } from "../../sections/AdminDashboard/shared/adminUx";
import DashboardMainContainer from "../../components/common/Containers/DashboardMainContainer";
import { CUSTOMER_CENTERED_PAGE_TITLE_CLASS } from "../../sections/CustomerDashboard/shared/customerLayoutSpec";

const CustDeactivate = () => {
  return (
    <DashboardMainContainer className="lg:px-5 lg:pb-10">
      <AdminPageTitle className={`text-offblack ${CUSTOMER_CENTERED_PAGE_TITLE_CLASS}`}>
        Close your customer account
      </AdminPageTitle>
      <div className="flex justify-center min-h-screen">
        <Deactivation />
      </div>
    </DashboardMainContainer>
  );
};

export default CustDeactivate;
